module.exports = __webpack_public_path__ + "img/p10.a2cbff38.png";